import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-[#0B0F14] to-[#00B4D8] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_trusted-journeys-co/artifacts/jq989m8x_365%20Transportation%20Logo%20White.png"
              alt="No Limit 365 Transportation"
              className="h-24 w-auto mb-4"
            />
            <p className="text-white/80 text-sm leading-relaxed">
              Specialized student transportation with trauma-informed care and whole-child support.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2 text-white/80">
              <li>
                <a href="#services" className="hover:text-white transition-colors">Services</a>
              </li>
              <li>
                <a href="#about" className="hover:text-white transition-colors">About Us</a>
              </li>
              <li>
                <a href="#training" className="hover:text-white transition-colors">Training</a>
              </li>
              <li>
                <a href="#faq" className="hover:text-white transition-colors">FAQ</a>
              </li>
              <li>
                <a href="#partnership" className="hover:text-white transition-colors">Partnership</a>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="font-bold text-lg mb-4">Service Areas</h4>
            <ul className="space-y-2 text-white/80 text-sm">
              <li>Northern California</li>
              <li>Bay Area Districts</li>
              <li>Central Valley</li>
              <li>SELPA Partnerships</li>
              <li>30-55 Mile Routes</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#0077BE] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-white/80 text-sm">365@transportationgroup.org</p>
                  <p className="text-white/80 text-sm">Nolimits365transportation@gmail.com</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#0077BE] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-white/80 text-sm">209-200-9884</p>
                  <p className="text-white/60 text-xs">24/7 Support Available</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#0077BE] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-white/80 text-sm">Serving California</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Copyright */}
            <p className="text-white/60 text-sm">
              © 2024 365 Transportation. All rights reserved.
            </p>

            {/* Legal Links */}
            <div className="flex items-center gap-4 text-white/60 text-sm">
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              <span>•</span>
              <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
